import { TransactionReportType } from 'src/type/report';
import { TransactionType } from 'src/type/transaction';

export const reportTypeOptions = [
  {
    label: 'ทุกประเภท',
    value: TransactionReportType.ALL,
  },
  {
    label: 'รายการเติม/ถอน',
    value: TransactionReportType.TOPUP_AND_WITHDRAW,
  },
  {
    label: 'ถอนสินค้า',
    value: TransactionReportType.REDEEM,
  },
  // {
  //   label: 'การตัดซื้อ/ตัดขาย',
  //   value: TransactionReportType.POSITION,
  // },
  {
    label: 'การตัดซื้อ',
    value: TransactionReportType.BUY_POSITION,
  },
  {
    label: 'การตัดขาย',
    value: TransactionReportType.SELL_POSITION,
  },
  {
    label: 'รายการฝากสินค้า',
    value: TransactionReportType.DEPOSIT,
  },
  {
    label: 'รายการรับเข้า/จ่ายออก',
    value: TransactionReportType.DEPOSIT_STOCK_AND_REDEEM_STOCK,
  },
];

export const periodTypeOptions = [
  { label: 'รายวัน', value: 'daily' },
  { label: 'รายสัปดาห์', value: 'weekly' },
  { label: 'รายเดือน', value: 'monthly' },
  { label: 'เลือกช่วงเวลาเอง', value: 'periot' },
];

export const txAction = (type?: TransactionType) => {
  switch (type) {
    case TransactionType.TOPUP_CREDIT:
      return 'เติมเครดิต';
    case TransactionType.WITHDRAW_CREDIT:
      return 'ถอนเครดิต';
    case TransactionType.BUY:
      return 'ซื้อทอง';
    case TransactionType.SELL:
      return 'ขายทอง';
    case TransactionType.REDEEM:
      return 'ถอนทอง';
    case TransactionType.CREDIT_LOAN:
      return 'กู้ยืมเครดิต';
    case TransactionType.PAY_CREDIT_LOAN:
      return 'คืนเครดิต';
    case TransactionType.BUY_POSITION:
      return 'ตัดซื้อ';
    case TransactionType.SELL_POSITION:
      return 'ตัดขาย';
    case TransactionType.DEPOSIT:
      return 'ฝากสินค้า';
    case TransactionType.DEPOSIT_STOCK:
      return 'รับเข้าสินค้า';
    case TransactionType.REDEEM_STOCK:
      return 'จ่ายออกสินค้า';

    default:
      return '';
  }
};
